<footer class="footer container-fluid bg-sec text-center">

    <!-- Logo -->
    <div class="row pt-5 pb-3">
        <div class="col-md-12">
            <img class="footer-logo" src="assets/images/logo-footer.png" alt="">
        </div>
    </div>

    <!-- Text -->
    <div class="row text-left">
        <div class="col-md-12">
            <a class="px-3" [href]="editorialUrls.privacy" target="_blank">{{'gen_privacy'| translate}}</a> |
            <a class="px-3" [href]="editorialUrls.terms" target="_blank">{{'gen_terms' | translate}}</a> |
            <a class="px-3 cursor-po-c" (click)="dialogService.openConsentDialog()">
                {{'gen_cookies_policy' | translate}}
            </a>
            |
            <a class="px-3" [href]="editorialUrls.help" target="_blank">{{'gen_help' | translate}}</a>
        </div>
    </div>

    <!-- Copyrights Live -->
    <div class="row py-3">
        <div class="col-md-12 ">
            <p>Copyright © {{copyYear}} All rights reserved</p>
            <p *ngIf="env.features.powerBy">{{'gen_powered' | translate}}
                <a href="https://cine.gr/" target="_blanck"><img class="cine-logo"
                        src="assets/images/cineLogo.png" /></a>
            </p>
        </div>
    </div>
</footer>